module.exports = __webpack_public_path__ + "img/control_icon3.c20958bc.png";